// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__mkfN+","modalDialog":"styles_modalDialog__KeGix","iframe":"styles_iframe__hB5Dy"};